import React from "react";

const PricingSection = ({ t }) => (
  <section className="pricing anim-section home-section" id="precios">
    <div className="home-container">
      <div className="section-head">
        <h2>{t.pricing.head}</h2>
        <p>{t.pricing.sub}</p>
      </div>
      <div className="pricing-grid">
        <article className="price-card card-animated anim-card">
          <h3>{t.pricing.starter.title}</h3>
          <p className="price-tag">{t.pricing.starter.price}</p>
          <ul>
            {t.pricing.starter.bullets.map((bullet) => (
              <li key={bullet}>{bullet}</li>
            ))}
          </ul>
          <button className="btn btn-outline" type="button">
            {t.buttons.cotizar}
          </button>
        </article>
        <article className="price-card featured card-animated anim-card">
          <h3>{t.pricing.pro.title}</h3>
          <p className="price-tag">{t.pricing.pro.price}</p>
          <ul>
            {t.pricing.pro.bullets.map((bullet) => (
              <li key={bullet}>{bullet}</li>
            ))}
          </ul>
          <button className="btn btn-primary" type="button">
            {t.buttons.solicitarDemo}
          </button>
        </article>
        <article className="price-card card-animated anim-card">
          <h3>{t.pricing.enterprise.title}</h3>
          <p className="price-tag">{t.pricing.enterprise.price}</p>
          <ul>
            {t.pricing.enterprise.bullets.map((bullet) => (
              <li key={bullet}>{bullet}</li>
            ))}
          </ul>
          <button className="btn btn-outline" type="button">
            {t.buttons.hablarVentas}
          </button>
        </article>
      </div>
    </div>
  </section>
);

export default PricingSection;
